import { DbTable } from '../db-table';
import { HttpClient } from '@angular/common/http';
import { Suggestion } from '../../../../core/_shared/models/product';
import { WebApiService } from '../../WebApiService';
export class DbSuggestions extends DbTable<Suggestion> {
    constructor(private http: HttpClient,private webApi:WebApiService) {
        super(http,webApi, "suggestions");
    }
}
